module.exports = __webpack_public_path__ + "img/kurand_ec_store_bnr2.ebcc4f04.png";